import { LocationPriceStream } from '../../enum/shared/location-price-stream';
import type { SectionWithProducts } from '../section/section-with-products';
import { SectionRowViewModel } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-section/product-section/section-row-view-models/SectionRowViewModel';
import { ColumnGrouping } from '../section/column-grouping';
import { ColumnUtils } from '../../../utils/column-utils';
import { PriceUtils } from '../../../utils/price-utils';
import { ProductMenu } from '../product-menu';
import { Fraction } from '../../enum/shared/fraction.enum';
import { FONT, FontStyleSheet } from '../font-style-sheets';
import { SectionColumnViewModel } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-section/product-section/section-column-view-models/SectionColumnViewModel';
import { SectionColumnProductInfoType } from '../../enum/shared/section-column-product-info-type';

export class IngramAndSonsMenu extends ProductMenu {
  public static readonly supportedDecimalsThatCanBeFractions: Fraction[] = [
    Fraction.Eighth,
    Fraction.Quarter,
    Fraction.ThreeEighths,
    Fraction.Half,
    Fraction.FiveEighths,
    Fraction.ThreeQuarters,
    Fraction.SevenEighths
  ];

  getThemeClass(): string {
    return 'ingram-and-sons-theme';
  }

  getTitleSectionTopMargin(): string {
    return '1rem';
  }

  getTitleSectionBottomMargin(): string {
    return '0.2rem';
  }

  getSectionHeaderUnderlined(): boolean {
    return false;
  }

  getPriceDecimal(
    priceStream: LocationPriceStream,
    locationId: number,
    s: SectionWithProducts,
    rowVM: SectionRowViewModel,
    colVm: SectionColumnViewModel
  ): string {
    const decimal = super.getPriceDecimal(priceStream, locationId, s, rowVM, colVm);
    const supportedFractions = IngramAndSonsMenu.supportedDecimalsThatCanBeFractions;
    return PriceUtils.getCertainDecimalsAsAsciiFractions(decimal, supportedFractions, true);
  }

  getSecondaryPriceDecimal(
    priceStream: LocationPriceStream,
    locationId: number,
    s: SectionWithProducts,
    rowVM: SectionRowViewModel,
    colVm: SectionColumnViewModel
  ): string {
    const decimal = super.getSecondaryPriceDecimal(priceStream, locationId, s, rowVM, colVm);
    const supportedFractions = IngramAndSonsMenu.supportedDecimalsThatCanBeFractions;
    return PriceUtils.getCertainDecimalsAsAsciiFractions(decimal, supportedFractions, true);
  }

  getLineModeColumnGroupings(sectionColumnViewModels: SectionColumnViewModel[]): ColumnGrouping[] {
    const outBadges = (sectionColumnViewModel: SectionColumnViewModel) => {
      return sectionColumnViewModel.columnType !== SectionColumnProductInfoType.Badge;
    };
    if (sectionColumnViewModels?.filter(outBadges)?.length >= 5) {
      return ColumnUtils.oneBigGrouping();
    }
    return ColumnUtils.standardizedGrouping();
  }

  getGridModeColumnGroupings(sectionColumnViewModels: SectionColumnViewModel[]): ColumnGrouping[] {
    const outBadges = (sectionColumnViewModel: SectionColumnViewModel) => {
      return sectionColumnViewModel.columnType !== SectionColumnProductInfoType.Badge;
    };
    if (sectionColumnViewModels?.filter(outBadges)?.length >= 7) {
      return ColumnUtils.oneBigGrouping();
    }
    return ColumnUtils.standardizedGrouping();
  }

  whatFontsAreNeededToRenderContent(): FontStyleSheet[] {
    return [
      FONT.Anton.Regular_400,
      FONT.Montserrat.Medium_500,
      FONT.Montserrat.Bold_700,
      FONT.Spectral.ExtraBold_800,
      FONT.Spectral.Bold_700
    ];
  }

  override getAdobeFontFamilyCssUrl(): string | null {
    return 'https://use.typekit.net/tiu3rfz.css';
  }
}
